import { DialogContent, DialogTitle, Divider, Grid, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import BakeasyLabelText from '../../components/labels/BakeasyLabelText';
import { AppContext } from '../../context/AppContext';
import { useAppSelector } from '../../redux_store/reduxStore';
import { OrderHistoryState } from '../../redux_store/slices/OrderHistorySlice';
import { formatDateTime } from '../../utils/DateUtils';
import { t } from 'i18next';
import { Close } from '@mui/icons-material';

interface SupplierNotesHistoryProps {
  from: string;
}

export const SupplierNotesHistory: React.FC<SupplierNotesHistoryProps> = ({ from }) => {
  let myContext = React.useContext(AppContext);

  const { selectedValue }: any = useAppSelector(
    from === 'orderDetails' ? OrderHistoryState : () => ({ selectedValue: null })
  );

  const [data, setData] = useState([]);

  function handleClose() {
    myContext.setDialog({ open: false });
  }

  useEffect(() => {
    if (selectedValue?.supplierNotes && selectedValue?.supplierNotes.length) {
      setData(selectedValue?.supplierNotes);
    }
  }, [selectedValue]);

  return selectedValue?.supplierNotes.length > 0 ? (
    <>
      <DialogTitle
        sx={{ margin: 0, padding: 2 }}
        style={{ fontWeight: 600, fontSize: '1.2rem' }}
        minWidth={200}
      >
        <Grid container sx={{ flexDirection: 'row' }}>
          {t('SUPPLIER_NOTES')}
        </Grid>
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={{ position: 'absolute', right: 8, top: 8, color: theme => theme.palette.grey[500] }}
      >
        <Close />
      </IconButton>
      <Divider />
      <DialogContent sx={{ margin: 0 }}>
        {data?.map((item: any, index: number) => (
          <Grid key={index} sx={{ marginBottom: '15px' }}>
            <BakeasyLabelText label={formatDateTime(item.date)} value={item.notes} />
          </Grid>
        ))}
      </DialogContent>
    </>
  ) : null;
  // return selectedValue?.supplierNotes.length > 0 ? (
  //   <Grid container px={2} py={1}>
  //     <Grid item container justifyContent={'space-between'}>
  //       <BakeasyHeaderLabel message="Supplier Notes" />
  //       <BakeasyButton label="Close" onClick={handleClose} />
  //     </Grid>
  //     <Grid item>
  //       <BakeasyDivider />
  //       {data?.map((item: any, index: number) => (
  //         <Grid key={index} sx={{ marginBottom: '15px' }}>
  //           <BakeasyLabelText label={formatDateTime(item.date)} value={item.notes} />
  //         </Grid>
  //       ))}
  //     </Grid>
  //   </Grid>
  // ) : null;
};
